import axios from 'axios'
import { ErrorWrapper, ResponseWrapper } from './utils'
import { BACKEND_URL, COOKIE_DOMAIN } from '../env'

var Vue = require('vue')

let BEARER = ''

export class AuthService {
  /**
   ******************************
   * @API
   ******************************
   */

  static async makeLogin ({ username, password }) {
    return new Promise((resolve, reject) => {
      axios.post(`${BACKEND_URL}/auth/login/`, { username, password })
        .then(response => {
          _setAuthData(response.data.auth_token, response.data.username)
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }

  static async makeRegister (_userData) {
    return new Promise((resolve, reject) => {
      axios.post(`${BACKEND_URL}/auth/users/`, _userData)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }

  // static async makeRegister (_userData) {
  //   return new Promise((resolve, reject) => {
  //     axios.post(`${BACKEND_URL}/auth/users/`, _userData)
  //       .then(response => {
  //         return resolve(new ResponseWrapper(response, response.data, ''))
  //       }).catch(error => reject(new ErrorWrapper(error)))
  //   })
  // }

  static makeLogout () {
    _resetAuthData()
    _resetCobrandingData()
  }

  static async sendPasswordResetEmail (_userData) {
    return new Promise((resolve, reject) => {
      axios.post(`${BACKEND_URL}/auth/password-reset-email/`, _userData)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }

  static async passwordResetConfirm (_userData) {
    return new Promise((resolve, reject) => {
      axios.post(`${BACKEND_URL}/auth/password-reset-confirm/`, _userData)
        .then(response => {
          return resolve(new ResponseWrapper(response, response.data, ''))
        }).catch(error => reject(new ErrorWrapper(error)))
    })
  }

  /**
   ******************************
   * @METHODS
   ******************************
   */

  static getAuthToken () {
    const cookieToken = Vue.default.cookie.get('token')
    return cookieToken || localStorage.getItem('genderAppToken')
  }

  static setAuthToken (refreshToken) {
    localStorage.setItem('genderAppToken', refreshToken)
    Vue.default.cookie.set('token', refreshToken, { expires: 9999 }, '/', COOKIE_DOMAIN)
  }

  static setUsername (refreshUsername) {
    localStorage.setItem('genderUsername', refreshUsername)
    Vue.default.cookie.set('username', refreshUsername, { expires: 9999 }, '/', COOKIE_DOMAIN)
  }

  static getBearer () {
    return BEARER
  }

  static setBearer (accessToken) {
    BEARER = `Bearer ${accessToken}`
  }
}

/**
 ******************************
 * @private_methods
 ******************************
 */

function _resetAuthData () {
  Vue.default.cookie.set('token', '', { expires: 0 })
  Vue.default.cookie.set('username', '')
  localStorage.removeItem('genderAppUsername')
  localStorage.removeItem('genderAppToken')
}
function _resetCobrandingData () {
  localStorage.removeItem('addin_bg_color')
  localStorage.removeItem('cobranding_logo_path')
}

function _setAuthData (token, username) {
  AuthService.setAuthToken(token)
  Vue.default.cookie.set('username', username, { expires: 9999 }, '/', COOKIE_DOMAIN)
  localStorage.setItem('genderAppUsername', username)
  const today = new Date()
  localStorage.setItem('genderAppLastLogin', today.toLocaleDateString('de-CH'))
}
